<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user-store'
import { VaButton } from 'vuestic-ui'

const router = useRouter()
const userStore = useUserStore()

async function signOut() {
  await userStore.signOut()
  router.push({ name: 'login' })
}
</script>

<template>
  <VaButton preset="primary" class="sign-out-btn" icon="logout" @click="signOut">Logout</VaButton>
</template>
